<template>
    <div class="l-container-content bg-white">
        <div class="row">
            <div class="col-6">
                <h3>All Tickets</h3>
            </div>
            <div class="col-6 text-right">
                <button type="button" @click="showModal()" class="button primary">Create Tickets</button>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="input inline">
                    <input name="dates" placeholder="Choose date" />
                </div>
            </div>
            <div class="col-6 text-right">
                <div class="input inline">
                    <input v-on:keyup.enter="searchRecord" type="text" placeholder="Search Client Mobile..." v-model="search_match">
                </div>
            </div>
        </div>
        <div class="row">
            <loader v-show="loading" />
            <vuetable ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :sort-order="sortOrder" track-by="msisdn" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                <div slot="status" slot-scope="props">
                     <strong :class="{'text-green':props.rowData.ticket_status_id== 3,'text-orange': props.rowData.ticket_status_id == 2, 'text-red': props.rowData.ticket_status_id == 1}">{{props.rowData.ticket_status_id | formartStatus}}</strong>
                </div>
                <div slot="sla_datetime" slot-scope="props">
                     <strong>{{props.rowData.sla_datetime | format_date_from}}</strong>
                </div>
                <div slot="action" slot-scope="props" >
                    <button class="button primary" id="commentBTN" @click="showCommentModal(props.rowData)" v-if="props.rowData.ticket_status_id!= 3"><i class="fas fa-reply-all"></i></button>
                    <button class="button view" id="commentBTN" @click="showComment(props.rowData)"><i class="fas fa-search-plus"></i></button>
                    <button class="button endStats" id="commentBTN" @click="closeTicket(props.rowData)" v-if="props.rowData.ticket_status_id!= 3"><i class="fas fa-check-circle"></i></button>
                    <button class="button edit" id="commentBTN" @click="showTicketAmount(props.rowData)" v-show="props.rowData.ticket_type_sub_id == 1 && props.rowData.ticket_status_id!= 3"><i class="fas fa-edit"></i></button>
                </div>
            </vuetable>
        </div>
        <div class="vuetable-pagination ui basic segment grid row">
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
    
            <div class="col-6  text-right">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
        </div>
        <b-modal ref="create-ticket-modal" hide-footer title="Create Ticket">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-6">
                    <label>Ticket Type*</label>
                    <select v-model="ticket_type_id"  @change="handleTicketSub">
                            <option value>Select Ticket Type</option>
                            <option v-for="(n,index) in ticketTypeList" :key="index+1" :value="n.ticket_type_id"> {{n.ticket_type}}</option>
                    </select>
                </div>
                <div class="col-6">
                    <label>Ticket Type*</label>
                    <select v-model="ticket_sub_type_id">
                            <option value>Select Ticket Sub Type</option>
                            <option v-for="(n,index) in ticketSubType" :key="index+1" :value="n.ticket_type_sub_id"> {{n.ticket_type_sub}}</option>
                    </select>
                </div>
                <div class="col-6">
                    <label>Ticket Priority*</label>
                    <select v-model="ticket_priority_id">
                            <option value>Select Ticket Priority</option>
                            <option v-for="(n,index) in ticketPriorityList" :key="index+1" :value="n.priority_id"> {{n.priority}}</option>
                    </select>
                </div>
                <!-- <div class="col-6">
                    <label>Assign User</label>
                    <select v-model="assignee_user_id">
                            <option value>Assign User</option>
                            <option v-for="(n,index) in usersList" :key="index+1" :value="n.user_id"> {{n.msisdn}}</option>
                    </select>
                </div> -->
                <div class="col-6" >
                    <label>Customer Mobile</label>
                    <input type="text" v-model="customer_msisdn" placeholder="Enter Mobile">
                </div>
                <div class="col-6" v-show="Hasreference">
                    <label>Date</label>
                   <input type="date" v-model="selectedDate">
                </div>
                <div class="col-6" v-show="Hasreference">
                    <label>Time</label>
                   <input type="time" v-model="selectedTime">
                </div>
                <div class="col-12" v-show="Hasreference">
                    <label>M-Pesa Reference</label>
                    <input type="text" v-model="ticketReference" placeholder="Enter Ticket Reference">
                </div>
                <div class="col-6" v-show="Hasreference">
                    <label>Account</label>
                    <input type="text" v-model="BillRefNumber" placeholder="Enter Account">
                </div>
                <div class="col-6" v-show="Hasreference">
                    <label>Amount</label>
                    <input type="text" v-model="billAmount" placeholder="Enter Amount">
                </div>
                <div class="col-12">
                    <label>Description</label>
                    <textarea rows="4" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="description" required />
                </div>
            </div>
            <b-button class="mt-3" variant="outline-success" block @click="createTicketType" id="createTicketType">Create Ticket Type</b-button>
            <b-button class="mt-2" variant="outline-danger" block @click="hideModal">Cancel</b-button>
        </b-modal>
        <b-modal ref="create-ticket-comment-modal" hide-footer :title="'Create Ticket Comment for ID: ' +selectedTickets.ticket_id ">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Comment *</label>
                    <textarea rows="4" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="description" required />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-success" block @click="createTicketComment" id="createComment">Save Comment</b-button>
                </div>
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-danger" block @click="hideCommentModal">Cancel</b-button>
                </div>
            </div>
        </b-modal>
        <b-modal ref="edit-ticket-amount-modal" hide-footer :title="'Update Withdraw Amount for ID: ' +selectedTickets.ticket_id ">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Amount</label>
                    <input type="number" v-model="selectedTickets.billAmount" placeholder="Enter Amount">
                </div>
                <div class="col-12">
                    <label>Account</label>
                    <input type="text" v-model="selectedTickets.BillRefNumber" placeholder="Enter Account">
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-success" block @click="editTicketAmount" id="updateAmount">Update Amount</b-button>
                </div>
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-danger" block @click="hideTicketAmount">Cancel</b-button>
                </div>
            </div>
        </b-modal>
        <b-modal ref="close-ticket-comment-modal" hide-footer :title="'Close Ticket ID: ' +selectedTickets.ticket_id ">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Comment *</label>
                    <textarea rows="4" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="description" required />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-success" block @click="closeTicketComment" id="createComment">Save Comment</b-button>
                </div>
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-danger" block @click="hideTicketClose">Cancel</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style>
td.vuetable-slot {
    overflow: visible !important;
}
</style>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";
import DatePicker from 'vue2-datepicker';

import store from "../../store";
import $ from "jquery";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        DatePicker,
        loader
    },
    name: "approvals",

    data() {
        return {
            loading: true,
            loadRecord: false,
            Hasreference: false,
            selected_data: {},
            ticket_type_id:1,
            ticket_sub_type_id:"",
            ticket_priority_id:"",
            ticketReference:"",
            ticketDate:"",
            customer_msisdn:"",
            description:"",
            url: "https://interactive.api.casino.chezagame.com/tickets/v1/view",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            columns: [{
                    name: "ticket_id",
                    title: 'Ticket ID',
                    sortField: "ticket_id",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },

                {
                    name: "msisdn",
                    title: "Customers",
                    sortField: "msisdn",
                    titleClass: "",
                    dataClass: ""
                },

                {
                    name: "priority",
                    title: "Priority",
                    sortField: "priority",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "priority_sla_hour",
                    title: "SLA (Hour)",
                    sortField: "priority_sla_hour",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "sla_datetime",
                    title: "SLA Date",
                    sortField: "sla_datetime",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "ticket_type",
                    title: "Type",
                    sortField: "ticket_type",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "status",
                    title: "Status",
                    sortField: "status",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "caller",
                    title: "Created By",
                    sortField: "caller",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "ticket_brief",
                    title: "Brief",
                    sortField: "ticket_brief",
                    titleClass: "",
                    dataClass: ""
                },
                

                {
                    name: "created_at",
                    title: "Date",
                    sortField: "created_at",
                    callback: "createdAt"
                },
                {
                    name: "action",
                    title: "Action",
                    resizable: true
                }
            ],
            range: "",
            search_match: "",
            loadOnStart: true,
            sortOrder: [{
                field: "created_at",
                direction: "desc"
            }],
            is_partial_resulting: false,

            moreParams: {
                start: "",
                filter: "",
                end: ""
            },
            ticketTypeList:[],
            ticketSubType:[],
            ticketPriorityList:[],
            usersList:[],
            selectedDate:"",
            selectedTime:"",
            assignee_user_id:"",
            selectedTickets:{
                ticket_id:"",
                ticket_brief:"",
                BillRefNumber:"",
                billAmount:0.00
            },
            BillRefNumber:"",
            billAmount:0.00,
            errorcreateStatus: false,
            errorsMessage: ""
        };
    },

    mounted() {

        var vm = this;
        if (vm.$cookies.get("role_id") != 1 && vm.$cookies.get("role_id") != 2) {
            vm.$router.push({
                name: "dashboard"
            });
        }

        vm.getTypeList()
        vm.handleTicketSub()
        vm.getPriorityList()
        vm.getUserList()

        var start = moment().subtract(120, "days");
        var end = moment();

        function cb(start, end) {
            vm.dateFilter(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
            $('input[name="dates"]').val(
                start.format("D MMMM, YYYY") + " - " + end.format("D MMMM, YYYY")
            );
        }

        $('input[name="dates"]').daterangepicker({
                startDate: start,
                endDate: end,
                ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days")
                    ],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "Last Month": [
                        moment()
                        .subtract(1, "month")
                        .startOf("month"),
                        moment()
                        .subtract(1, "month")
                        .endOf("month")
                    ]
                }
            },
            cb
        );

        cb(start, end);

       
    },

    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {
            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format("YYYY-MM-DD");
            end = moment(end).format("YYYY-MM-DD");
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },

    methods: {
       
        showModal() {
            this.$refs['create-ticket-modal'].show()
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        hideModal() {
            this.$refs['create-ticket-modal'].hide()
            this.$refs.vuetable.refresh();
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        showCommentModal(app) {
            this.$refs['create-ticket-comment-modal'].show()
            this.selectedTickets =  app
            this.errorcreateStatus = false
            this.errorsMessage = ""

        },
        closeTicket(app){
            this.selectedTickets =  app
            this.errorcreateStatus = false
            this.errorsMessage = ""
            this.$refs['close-ticket-comment-modal'].show()
            
        },
        showTicketAmount(app){
            this.selectedTickets =  app
            this.$refs['edit-ticket-amount-modal'].show()
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
       
        hideTicketClose(){
            this.$refs['close-ticket-comment-modal'].hide()
            this.$refs.vuetable.refresh();
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        hideCommentModal(){
            this.$refs['create-ticket-comment-modal'].hide()
            this.$refs.vuetable.refresh();
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        showComment(app){
            this.$router.push({ name: 'ticketAction', params: { id: app.ticket_id } })
        },
        dateFilter: function(start, end) {
            var vm = this;

            vm.start = start;
            vm.end = end;

            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start);
            console.log("end date filter ", end);
        },
        createdAt: function(value) {
            if (!value) {
                return "-";
            } else {
                return moment(value).format("h:mm a,DD MMM YYYY");
            }
        },

        searchRecord: function() {
            this.loadRecord = true;
            var str = this.search_match;
            var newString = str.indexOf("0") == 0 ? str.substring(1) : str;
            this.moreParams.filter = "254" + newString;
            this.$refs.vuetable.refresh();
        },

        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log("pagination:", pagination);
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },

        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData);
            this.$refs.pagination.setPaginationData(paginationData);
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true;
            console.log("loading... show your spinner here");
        },
        onLoaded() {
            this.loading = false;
            console.log("loaded! .. hide your spinner here");
            $(".ui.dropdown").dropdown();
        },
        getTypeList() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'tickets/v1/view/type',
                type: "get",
                async: true,
                data: {
                    "per_page": 20
                },
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;
                    
                        vm.ticketTypeList = response.data
                    
                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });


        },
        getUserList() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/view/system/user',
                type: "get",
                async: true,
                data: {
                    "per_page": 20
                },
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;
                    
                        vm.usersList = response.data
                    
                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });


        },
        getPriorityList() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'tickets/v1/view/priority',
                type: "get",
                async: true,
                data: {
                    "per_page": 20
                },
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;
                    
                        vm.ticketPriorityList = response.data
                    
                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });


        },
        handleTicketSub(){
            let vm = this
            if(vm.ticket_type_id == 1){
                vm.Hasreference = true
            } else {
                vm.Hasreference = false
            }
            $.get({
                url: store.state.rootUrl + 'tickets/v1/view/sub/type',
                type: "get",
                async: true,
                data: {
                    "per_page": 30,
                    "ticketTypeID":vm.ticket_type_id
                },
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;
                    
                        vm.ticketSubType = response.data
                    
                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });
        },
        createTicketType(){
            let vm  = this
            $("#createPriority").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'tickets/v1/create',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    ticket_type_sub_id: vm.ticket_sub_type_id,
                    priority_id: vm.ticket_priority_id,
                    reference_id: vm.ticketReference,
                    ticket_brief: vm.description,
                    windowStart: vm.selectedDate+" "+vm.selectedTime,
                    msisdn: vm.customer_msisdn,
                    assignee_user_id: vm.assignee_user_id,
                    billAmount: vm.billAmount,
                    BillRefNumber: vm.BillRefNumber

                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#createPriority").text("Create Tickets");
                    if (response.data.code == 200) {
                        vm.hideModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#createPriority").text("Create Priority");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
        createTicketComment(){
            let vm  = this
            $("#createComment").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'tickets/v1/create/comment',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    ticket_id: vm.selectedTickets.ticket_id,
                    action: vm.description

                }),
                success: function(response, status, jQxhr) {
                    $("#createComment").text("Create Comment");
                    if (response.data.code == 200) {
                        vm.hideCommentModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#createComment").text("Create Comment");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
        editTicketAmount(){
            let vm  = this
            $("#updateAmount").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'tickets/v1/edit/amount',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    ticket_id: vm.selectedTickets.ticket_id,
                    amount: vm.selectedTickets.billAmount,
                    billRefNumber: vm.selectedTickets.BillRefNumber

                }),
                success: function(response, status, jQxhr) {
                    $("#updateAmount").text("Update Amount");
                    if (response.data.code == 200) {
                        vm.hideTicketAmount()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#updateAmount").text("Update Amount");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
        closeTicketComment(){
            let vm  = this
            $("#createComment").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'tickets/v1/close',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    ticket_id: vm.selectedTickets.ticket_id,
                    message: vm.description,
                    status: 1

                }),
                success: function(response, status, jQxhr) {
                    $("#createComment").text("Create Comment");
                    if (response.data.code == 200) {
                        vm.hideTicketClose()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#createComment").text("Create Comment");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
    },
    filters: {
        formartStatus(value) {
            if (value == "1") {
                return "Unassigned"
            } else if (value == "2") {
                return "Assigned"
            } else if (value == "3") {
                return "Closed"
            } else {
                return "Progress"
            }
        },
        format_date(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            } else {
                return ""
            }
        },
        format_date_from(value) {
            if (value) {
                return moment(String(value)).fromNow();
            } else {
                return ""
            }
        },
    }
};
</script>
